import React, { ReactNode } from 'react';
import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

type IconLabelProps = {
  icon?: React.ComponentType<CustomIconComponentProps | React.SVGProps<SVGSVGElement>>;
  text: ReactNode;
};

const IconLabel = ({ icon, text }: IconLabelProps) => {
  return icon ? (
    <span>
      <Icon component={icon} /> {text}
    </span>
  ) : (
    <span>{text}</span>
  );
};

export default IconLabel;
